import React, { Fragment } from "react";

export default (
  <>
    <path d="M12 22.4s7.6-4.1 10.8-10-.3-10.6-5.2-10.8S12 5.7 12 5.7s-.7-4.2-5.6-4.1-8.4 5-5.2 10.8 10.8 10 10.8 10z" />
  </>
);
